import LineChartBase from './line_chart_base'
// Connects to data-controller="ex-line-chart"
export default class extends LineChartBase {
  setVisitorStatistics ({ detail }: any): void {
    this.chart.data = detail
    this.chart.update()
  }
}
